module.exports = __webpack_public_path__ + "static/media/自动驾驶遥控车.f4594aff.png";